import modal from './domainStatus/modal'

export default {
  domain_available: {
    status: 'success',
    message: 'O domínio está livre para registro e pode ser seu',
    description: 'Para comprar esse domínio, basta clicar no botão abaixo e seguir as etapas de contratação.',
    buttonLabel: 'Comprar domínio'
  },
  domain_not_configured: {
    status: 'warning',
    message: 'Este domínio está registrado fora da Locaweb',
    description: `Mude seu apontamento ou
                 <a target="_blank" href="https://ajuda.locaweb.com.br/wiki/transferencia-de-dominio-internacional">
                 faça sua transferência para a locaweb</a>`,
    modal
  }
}
